import * as z from "zod";

export const deleteOdooIntegration = {
  name: "deleteOdooIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
